<nav
  class="navbar navbar-horizontal navbar-nhc navbar-main navbar-expand-lg navbar-light"
  id="navbar-main"
>
  <div class="container">
    <a [routerLink]="['/']" class="navbar-brand">
      <!-- <img src="assets/img/brand/white.png" /> -->
      <img src="https://www.nhc.no/content/themes/nhc/dist/static/logo.25125296.png"/>
      Norwegian Helsinki Committee
    </a>
    <button
      (click)="isCollapsed = !isCollapsed"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseBasic"
      aria-expanded="false"
      aria-label="Toggle navigation"
      class="navbar-toggler"
      data-target="#navbar-collapse"
      data-toggle="collapse" type="button"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      [collapse]="isCollapsed"
      class="navbar-collapse navbar-custom-collapse collapse" id="collapseBasic"
    >
      <div class="navbar-collapse-header">
        <div class="row">
          <div class="col-6 collapse-brand">
            <a [routerLink]="['/']">
              <img src="assets/img/brand/blue.png"/>
            </a>
          </div>
          <div class="col-6 collapse-close">
            <button
              (click)="isCollapsed = !isCollapsed"
              aria-controls="navbar-collapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
              class="navbar-toggler"
              data-target="#navbar-collapse"
              data-toggle="collapse"
              type="button"
            >
              <span></span> <span></span>
            </button>
          </div>
        </div>
      </div>
      <hr class="d-lg-none"/>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
      </ul>
    </div>
  </div>
</nav>
<router-outlet></router-outlet>
<footer >
  <div class="container">
    <div class="row align-items-center justify-content-xl-between">
      <div class="col-xl-12">
        <div class="copyright text-center text-xl-left text-muted">
          &copy; {{ test | date: "yyyy" }}
          <a
            class="font-weight-bold ml-1"
            href="https://www.cartagena.no"
            target="_blank"
          >Cartagena AS</a
          >
        </div>
      </div>
    </div>
  </div>
</footer>
